export const useDotsPane = () => {
  const {
    sharpness,
    cellSize,
    radius,
    brightness,

    ambientSpeed,
    ambientScale,
    ambientCutoff,
    ambientStrength,
    ambientMorph,
    ambientDotScale,

    ambientMaskTop,
    ambientMaskBottom,
    ambientMaskCenter,

    flowMapSize,
    flowMapFalloff,
    flowMapDissipation,
    flowMapStrength,

    scaleRadius,
    scaleStrength,
  } = useDots()

  // **********************************************************************
  // SETTINGS
  // **********************************************************************

  usePane(
    [
      {
        name: "Sharpness",
        value: sharpness,
        options: {
          min: 1,
          max: 10000.0,
          step: 10,
        },
      },
      {
        name: "Cell Size",
        value: cellSize,
        options: {
          min: 0.1,
          max: 2.0,
          step: 0.01,
        },
      },
      {
        name: "Radius",
        value: radius,
        options: {
          min: 0.0001,
          max: 0.01,
          step: 0.0001,
        },
      },

      // {
      //   name: "Cell Size",
      //   value: cellSize,
      //   options: {
      //     min: 1,
      //     max: 100.0,
      //     step: 1,
      //   },
      // },
      // {
      //   name: "Radius",
      //   value: radius,
      //   options: {
      //     min: 1,
      //     max: 4,
      //     step: 0.1,
      //   },
      // },

      {
        name: "Brightness",
        value: brightness,
        options: {
          min: 0.01,
          max: 1.0,
          step: 0.01,
        },
      },
    ],
    {
      title: "Grid",
      expanded: true,
    }
  )

  // **********************************************************************
  // AMBIENT
  // **********************************************************************

  usePane(
    [
      {
        name: "Speed",
        value: ambientSpeed,
        options: {
          min: 0,
          max: 1.0,
          step: 0.01,
        },
      },

      {
        name: "Scale",
        value: ambientScale,
        options: {
          min: 0.1,
          max: 10.0,
          step: 0.1,
        },
      },

      {
        name: "Cutoff",
        value: ambientCutoff,
        options: {
          min: 0,
          max: 1.0,
          step: 0.05,
        },
      },

      {
        name: "Opacity",
        value: ambientStrength,
        options: {
          min: 0.0,
          max: 1.0,
          step: 0.05,
        },
      },
      {
        name: "Morph",
        value: ambientMorph,
        options: {
          min: 0.0,
          max: 100.0,
          step: 0.1,
        },
      },
      {
        name: "Dot Scale",
        value: ambientDotScale,
        options: {
          min: 0.0,
          max: 5.0,
          step: 0.1,
        },
      },
    ],
    {
      title: "Ambient",
      expanded: true,
    }
  )

  usePane(
    [
      {
        name: "Mask Top",
        value: ambientMaskTop,
        options: {
          min: 0.0,
          max: 1.0,
          step: 0.05,
        },
      },
      {
        name: "Mask Bottom",
        value: ambientMaskBottom,
        options: {
          min: 0.0,
          max: 1.0,
          step: 0.05,
        },
      },
      {
        name: "Mask Center",
        value: ambientMaskCenter,
        options: {
          min: 0.0,
          max: 1.0,
          step: 0.05,
        },
      },
    ],
    {
      title: "Ambient Mask",
      expanded: true,
    }
  )

  // **********************************************************************
  // FLOW MAP
  // **********************************************************************

  usePane(
    [
      {
        name: "Resolution",
        value: flowMapSize,
        options: {
          min: 8,
          max: 1024,
          options: {
            8: 8,
            16: 16,
            32: 32,
            64: 64,
            128: 128,
            256: 256,
            512: 512,
            1024: 1024,
          },
        },
      },
      {
        name: "Falloff",
        value: flowMapFalloff,
        options: {
          min: 0.1,
          max: 1.0,
          step: 0.01,
        },
      },

      {
        name: "Dissipation",
        value: flowMapDissipation,
        options: {
          min: 0.9,
          max: 1.0,
          step: 0.005,
        },
      },

      {
        name: "Strength",
        value: flowMapStrength,
        options: {
          min: 0.0,
          max: 1.0,
          step: 0.01,
        },
      },
    ],
    {
      title: "Mouse Flow Map",
      expanded: true,
    }
  )

  // **********************************************************************
  // SCALE
  // **********************************************************************

  usePane(
    [
      {
        name: "Radius",
        value: scaleRadius,
        options: {
          min: 0,
          max: 1000.0,
          step: 1,
        },
      },
      {
        name: "Strength",
        value: scaleStrength,
        options: {
          min: 0,
          max: 5.0,
          step: 0.1,
        },
      },
    ],
    { title: "Mouse Scale", expanded: true }
  )
}
